
/**
 * 组装数据
 */
export default ({
  configData = {}, // 配置数据
  urlData = {}, // url 数据
  systemData = {}, // 系统数据
  clientData = {}, // 客户端数据
  collectData = {}, // 流程数据
  params = {}, // 其他数据
  customJson = {}
} = {}) => {
  return {
    commons: {
      departmentID: 'financing', // 部门ID（财富）,由数据部门确定
      businessID: 'behaviour_common', // 业务ID,由数据部门确定
      udid: clientData.udid || '', // 用户设备号
      channel: clientData.channel || '', // 安装包渠道名称，iOS传空
      system_name: systemData.systemName || '', // 系统名称，[android OS、iPhone OS、other]
      system_version: systemData.systemVersion || '', // 系统版本，如10.0.1，7.0
      appName: clientData.appName || '', // 终端名称，比如：MyMoney For Miui
      appVersion: clientData.appVersion || '', // 终端版本号，比如10.0.4.5
      cookieid: systemData.cookieid || '', // 没有udid时用户的唯一标示
    },
    events: [{
      session_id: systemData.sessionId || '', // session_id
      url: window.location.href, // 页面地址，浏览行为上传当前页面url，点击行为上传对象url
      title: configData.title || '', // 页面标题/点击对象标题,浏览页面行为时上传页面标题，点击对象行为时上传点击对象标题，必填，不能为空
      etype: configData.etype || '', // 动作类型,浏览页面还是点击对象 浏览：view 点击：click
      sku: collectData.flowName || '', // 流程名称
      page_name: collectData.pageName || '', // 流程步骤页名称
      order_id: params.orderId || '', // 订单号，产生订单交易时候上传
      amount: params.amount || '', // 购买金额
      inner_media: urlData.inner_media || '', // 内部媒体
      outer_media: urlData.outer_media || '', // 外部媒体参数
      referrer: document.referrer || '', // 访前页面，浏览该页面时的上一个页面
      useragent: window.navigator.userAgent, // 当前用户所使用的浏览器信息，由服务端获取
      product_id: params.productId || '', // 产品id
      client_id: systemData.clientid || '', // 渠道号[01,04,12]
      sub_client_id: systemData.subClientid || '', // 二级渠道号[suishouji,suiguanjia,cardniu,yunzhijia,wechat,h5]
      adid: urlData.adid || '', // 广告ID
      cid: urlData.cid || '',
      appstoreid: urlData.appstoreid || '',
      idfa: clientData.idfa || '',
      ...customJson,
    }]
  }
}


// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/node_modules/@common/collect/src/data/data_tpl.js